import { theme } from 'antd';
import React from 'react';
import { Flex, Typography } from 'zui/Antd';
import LoaderComponent from './styles';

const { Text } = Typography;
const Loader = ({ subTitle, isError, ...props }) => {
	const {
		token: { colorBgContainer, colorError, colorPrimary }
	} = theme.useToken();

	return (
		<LoaderComponent {...props} style={{ background: colorBgContainer }}>
			<Flex gap={8} vertical justify='center' align='center'>
				<svg className='isoContentLoader' viewBox='0 0 50 50'>
					<circle
						className='isoContentLoaderCircle'
						stroke={isError ? colorError : colorPrimary}
						cx='25'
						cy='25'
						r='20'
						fill='none'
						strokeWidth='3.6'
					/>
				</svg>
				<Text style={{ color: isError ? colorError : colorPrimary }} strong>
					{subTitle}
				</Text>
			</Flex>
		</LoaderComponent>
	);
};

export default Loader;
